type FormErrorProps = {
  message?: string;
};

export const FormError = ({ message }: FormErrorProps) => {
  return message ? (
    <div
      role="alert"
      className="mt-2 rounded-2xl bg-feedback-error-surface p-3 text-sm drop-shadow-sm first-letter:capitalize"
    >
      {message}
    </div>
  ) : null;
};
